var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme'; // import { Icon, classNames, useComponentColor, useLink } from '@shapeable/web';

import { Icon } from './icon';
import { classNames } from '../../utils/cn';
import { useComponentColor } from '../../hooks/use-component-color';
import { useLink } from '../../hooks/use-link';
import { TextBubble } from './text-bubble';
var cls = classNames('lang-menu-item');
export var LangMenuItemDefaultProps = {
  iconSize: 20
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    font-size: 1em;\n    \n    a {\n      display: flex;\n      width: 100%;\n      box-sizing: border-box;\n      justify-content: flex-start;\n      align-items: center;\n      text-decoration: none;\n      padding: ", " ", ";\n\n      .shp--text-bubble {\n        color: ", ";\n      }\n\n      ", "\n\n      ", "\n\n      ", "\n\n    }\n  "], ["\n    display: flex;\n    font-size: 1em;\n    \n    a {\n      display: flex;\n      width: 100%;\n      box-sizing: border-box;\n      justify-content: flex-start;\n      align-items: center;\n      text-decoration: none;\n      padding: ", " ", ";\n\n      .shp--text-bubble {\n        color: ", ";\n      }\n\n      ", "\n\n      ", "\n\n      ", "\n\n    }\n  "])), theme.UNIT(3), theme.UNIT(4), theme.COLOR('dark'), function (_a) {
    var isActive = _a.isActive,
        _activeColor = _a._activeColor,
        _color = _a._color;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        .shp--text-bubble {\n          background: ", ";\n        }\n      "], ["\n        .shp--text-bubble {\n          background: ", ";\n        }\n      "])), isActive ? _activeColor : _color);
  }, function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        cursor: default;\n      "], ["\n        cursor: default;\n      "])));
  }, function (_a) {
    var _color = _a._color,
        _hoverColor = _a._hoverColor,
        _hoverBackgroundColor = _a._hoverBackgroundColor,
        _activeColor = _a._activeColor,
        isActive = _a.isActive;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        ", ";\n        color: ", ";\n        ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n          ", ";\n        }\n      "], ["\n        ", ";\n        color: ", ";\n        ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n          ", ";\n        }\n      "])), theme.FILL(_color), theme.COLOR(isActive ? _activeColor : _color), theme.FILL(isActive ? _activeColor : _color), theme.COLOR(isActive ? _activeColor : _hoverColor), isActive ? 'transparent' : _hoverBackgroundColor, theme.FILL(isActive ? _activeColor : _hoverColor));
  }),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var LabelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    text-transform: inherit;\n    white-space: nowrap;\n  "], ["\n    text-transform: inherit;\n    white-space: nowrap;\n  "])))
});
var TextBubbleStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(3))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  TextBubble: styled(TextBubble)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TextBubbleStyles)
};
export var LangMenuItem = function LangMenuItem(props) {
  var className = props.className,
      children = props.children,
      href = props.href,
      icon = props.icon,
      abbrev = props.abbrev,
      isActive = props.isActive,
      label = props.label,
      iconSize = props.iconSize,
      isInverted = props.isInverted,
      onClick = props.onClick;
  var Link = useLink().Link;
  var color = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.color,
    sub: 'link',
    fallbacks: ['link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link', 'light']
  });
  var hoverColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.hoverColor,
    sub: 'link-hover',
    fallbacks: ['menu-hover', 'link-hover', 'dark-brand', 'dark', 'primary'],
    invertedFallbacks: ['inverted-menu-hover', 'inverted-link-hover', 'light']
  });
  var hoverBackgroundColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.hoverBackgroundColor,
    sub: 'link-hover-background',
    fallbacks: ['menu-hover-background', 'light-brand', '#EEEEEE'],
    invertedFallbacks: ['inverted-menu-hover-background', 'mid-brand', '#666']
  });
  var activeColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.activeColor,
    sub: 'link-active',
    fallbacks: ['menu-active', 'link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-menu-active', 'inverted-link-active', 'mid-brand', 'primary']
  });
  return React.createElement(My.Container, {
    onClick: onClick,
    isActive: isActive,
    _color: color,
    _hoverColor: hoverColor,
    _activeColor: activeColor,
    _hoverBackgroundColor: hoverBackgroundColor,
    className: cls.name(className)
  }, React.createElement(Link, {
    patchLang: false,
    href: href
  }, icon ? React.createElement(My.Icon, {
    size: iconSize
  }, icon) : React.createElement(My.TextBubble, {
    size: 32
  }, abbrev), React.createElement(My.Label, null, label || children)));
};
LangMenuItem.cls = cls;
LangMenuItem.defaultProps = LangMenuItemDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;